import { IProfile } from '@jumpstart/core';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { getDatabase, ref, update } from "firebase/database";
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import CloseIcon from '@mui/icons-material/Close';
import * as ChangeCase from 'change-case';
import { collection, getFirestore } from 'firebase/firestore';
import React, { Fragment, ReactNode, useState } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { app, db } from '../../../core/firebase';
import { ISubscriber } from '../schema';
import ProfileJson from './action-views/ProfileJson';
import CustomerInfo from './CustomerInfo';
import ActionDialogTitle from './widgets/ActionDialogTitle';

export interface ICustomerView {
  subscriber: ISubscriber | null;
  subscriberProfile: IProfile | null;
}

type View = 'none' | 'profile' | 'notes' | 'transactions' | 'scheduled-messages';
export default function CustomerView(props: ICustomerView) {
  const { subscriberProfile, subscriber } = props;
  const [view, setView] = useState<View>('none');
  const [tasks] = useCollection(collection(
    getFirestore(app),
    'scout9-sms-subscribers',
    subscriber ? subscriber.uid : 'UNKNOWN',
    'tasks'
  ));

  const handleProfileUpdate = (updates: IProfile) => {
    setView('none');
    const db = getDatabase();
    update(ref(db, `scout9-profiles/${updates.id}`), updates)
      .then(() => {
        console.log('Profile Updated');
      })
      .catch((err: Error) => {
        console.error('Failed to update user', err.message);
      });
  }

  if (!subscriberProfile || !subscriber) {
    return null;
  }

  return (
    <Fragment>
      <Grid
        sx={{
          overflow: 'hidden',
          width: '100%'
        }}
        direction="column"
        container wrap="nowrap"
      >
        <CustomerInfo subscriber={subscriber} subscriberProfile={subscriberProfile}/>
        <List dense>
          {
            ['profile', 'notes', 'transactions', 'scheduled-messages']
              .map((action: string) =>
                <ListItem disablePadding key={`action-${action}`}>
                  <ListItemButton onClick={() => setView(action as View)}>
                    <ListItemText primary={ChangeCase.headerCase(action)}/>
                  </ListItemButton>
                </ListItem>
              )
          }
        </List>
      </Grid>

      <Dialog
        open={view === 'profile'}
        onClose={() => setView('profile')}
      >
        <ActionDialogTitle id="action-profile" onClose={() => setView('none')}>
          Profile Data
        </ActionDialogTitle>
        <DialogContent>
          {subscriberProfile && <ProfileJson subscriberProfile={subscriberProfile} onSubmit={handleProfileUpdate}/>}
        </DialogContent>
      </Dialog>

      <Dialog
        open={view === 'notes'}
        onClose={() => setView('none')}
      >
        <ActionDialogTitle id="action-notes" onClose={() => setView('none')}>
          Notes
        </ActionDialogTitle>
        <DialogContent>
          Implement Me
        </DialogContent>
      </Dialog>

      <Dialog
        open={view === 'transactions'}
        onClose={() => setView('none')}
      >
        <ActionDialogTitle id="action-transactions" onClose={() => setView('none')}>
          Transactions
        </ActionDialogTitle>
        <DialogContent>
          Implement Me
        </DialogContent>
      </Dialog>

      <Dialog
        open={view === 'scheduled-messages'}
        onClose={() => setView('none')}
      >
        <ActionDialogTitle id="action-scheduled" onClose={() => setView('none')}>
          Scheduled Messages
        </ActionDialogTitle>
        <DialogContent>
          Implement Me
        </DialogContent>
      </Dialog>

    </Fragment>
  );
}
